import bluebird from 'bluebird';
import redis from 'redis';
import {axios} from '@http_client';
import {$httpToNodeJs} from "./http_to_nodejs";
import {isEmpty} from "../components/helpers/helpers";
import md5 from "md5";

const cachePrefix = (process.env.NEXT_PUBLIC_APP_ENV === 'production') ? 'next_prod' : 'next_dev';

/**
 * @param cacheKey {String}
 * @param path {String} // api url
 * @param timeToLive {nullable|number} // percent (600 => 10 min)
 * @param method {string} // get || post
 * @param requestData {Object}
 * @param manageCacheKey {Boolean}
 *
 * @return Promise
 * */
export function $http(cacheKey, path, timeToLive = 600, method = 'get', requestData = null, manageCacheKey = false) {
    if (!process.browser) {
        const client = redis.createClient({db: process.env.NEXT_PUBLIC_REDIS_DB});
        const fullCacheKey = cachePrefix + ':' + cacheKey;

        bluebird.promisifyAll(redis.RedisClient.prototype);

        return new Promise((resolve, reject) => {
            client.get(fullCacheKey, async (err, cachedData) => {
                let data = {};

                if (err) reject(err);

                if (cachedData) {
                    // console.log(cacheKey, 'cache')
                    data = JSON.parse(cachedData);
                } else {
                    // console.log(cacheKey, 'axios')

                    data = await getAxios(path, method, requestData, timeToLive, cacheKey, manageCacheKey);

                    if (!isEmpty(data) && !isEmpty(cacheKey)) {
                        client.set(fullCacheKey, JSON.stringify(data), 'EX', timeToLive, redis.print);
                    }
                }

                resolve(data)
            });
        });
    } else {
        return new Promise((resolve, reject) => {
            getAxios(path, method, requestData, timeToLive, cacheKey, manageCacheKey).then(result => {
                resolve(result)
            }).catch(err => {
                reject(err)
            });
        });
    }
}

/* Client cache data */
const queryClientData = {};


async function getAxios(path, method, requestData, timeToLive, cacheKey, manageCacheKey = false) {
    let result = {data: null};

    const reqCacheKey = cacheKey ? cacheKey : md5(path);

    if ((method !== 'post' || cacheKey) && process.browser) {
        if (queryClientData[reqCacheKey]) {
            return queryClientData[reqCacheKey];
        }
    }

    if (!isEmpty(cacheKey)) {
        if (method === 'post') {
            result = await $httpToNodeJs(path, timeToLive, cacheKey, manageCacheKey).post('/turbu/getData', requestData);
        } else {
            result = await $httpToNodeJs(path, timeToLive, cacheKey, manageCacheKey).get('/turbu/getData');
        }
    } else {
        if (method === 'post') {
            result = await axios.post(path, requestData);
        } else {
            result = await axios.get(path);
        }
    }

    if (method !== 'post' || cacheKey) {
        queryClientData[reqCacheKey] = result.data;
    }

    return result.data;
}
